import type { FieldsetDesignTokens } from '@primeuix/themes/types/fieldset'

export default {
  root: {
    color: '{content.color}',
    padding: '0.75rem 1.125rem 1.125rem 1.125rem',
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    transitionDuration: '{transition.duration}',
  },
  legend: {
    gap: '0.5rem',
    padding: '0.625rem 0.875rem',
    focusRing: {
      color: '{focus.ring.color}',
      style: '{focus.ring.style}',
      width: '{focus.ring.width}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    fontWeight: '700',
    borderColor: '{content.border.color}',
    borderWidth: '1px',
    borderRadius: '{content.border.radius}',
  },
  content: {
    padding: '0',
  },
  toggleIcon: {
    color: '{text.muted.color}',
    hoverColor: '{text.hover.muted.color}',
  },
  colorScheme: {
    dark: {
      legend: {
        color: '{text.color}',
        background: '{surface.800}',
        hoverColor: '{text.hover.color}',
        hoverBackground: '{surface.700}',
      },
    },
    light: {
      legend: {
        color: '{text.color}',
        background: '{surface.50}',
        hoverColor: '{text.hover.color}',
        hoverBackground: '{surface.100}',
      },
    },
  },
} satisfies FieldsetDesignTokens
